import './LaunchOfferAnimation.css';

export default function LaunchOfferAnimation({ className }) {
  const classes = className
    ? `launch-offer-animation ${className}`
    : 'launch-offer-animation';

  return (
    <div className={classes} aria-hidden="true">
      <div className="launch-offer-animation__orbit">
        <div className="launch-offer-animation__rocket">
          <div className="launch-offer-animation__body">
            <span className="launch-offer-animation__window" />
          </div>
          <span className="launch-offer-animation__fin launch-offer-animation__fin--left" />
          <span className="launch-offer-animation__fin launch-offer-animation__fin--right" />
          <span className="launch-offer-animation__flame" />
        </div>
      </div>
      <div className="launch-offer-animation__sparkfield">
        <span className="launch-offer-animation__spark launch-offer-animation__spark--1" />
        <span className="launch-offer-animation__spark launch-offer-animation__spark--2" />
        <span className="launch-offer-animation__spark launch-offer-animation__spark--3" />
        <span className="launch-offer-animation__spark launch-offer-animation__spark--4" />
      </div>
    </div>
  );
}
